; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.mastertag = {
        name: 'mastertag',

        version: '1.0.0',

        settings: {
            trigger: '',    // 'click' ou 'autopromo'
            event: '',     // 'C' ou 'autopromo_click'
            type: '',     // 'N'=Navigation, 'S'=Sortie, 'A'=Action, 'T'=Téléchargement
            level: '',      // N° de site de Niveau 2 AT Internet
            label: '',      // Chapitrage AT Internet avec notation chapitre::sous_chapitre::clic
            name: '',       // Libellé de l'event
            product_size: '',       // Taille du produit
            product_add_type: '',   // 'classique', 'catalogue', 'mixte' => Type d'ajout au panier
            completeCallback: function (request, status) { }
        },

        init: function (scope, method, options) {
            this.settings = this.settings || $.extend({}, this.defaults, (options || method));

            // à conserver
            this.bindings(method, options);
        },

        // Méthode globale 
        track_event: function (obj, trigger, options) {
            if (typeof (tC) !== "undefined" && tC && tC.event) {
                switch (trigger) {
                    case "clic_menu":
                        if (typeof tC.event.clic_menu === "function") {
                            tC.event.clic_menu(this, options);
                        }
                        break;
                    case "clic_carrousel_produits":
                    case "clic_liste_produit":
                    case "clic_wishlist_produit":
                    case "clic_configurateur_produit":
                        if (typeof tC.event.product_click === "function") {
                            tC.event.product_click(this, options);
                        }
                        break;
                    case "ajout_panier":
                        if (typeof tC.event.ajout_panier === "function") {
                            tC.event.ajout_panier(this, options);
                        }
                        break;
                    case "clic_favoris":
                        if (typeof tC.event.clic_favoris === "function") {
                            tC.event.clic_favoris(this, options);
                        }
                        break;
                    case "e_reservation":
                        if (typeof tC.event.e_reservation === "function") {
                            tC.event.e_reservation(this, options);
                        }
                        break;
                    case "onglet_fp":
                        if (typeof tC.event.onglet_fp === "function") {
                            tC.event.onglet_fp(this, options);
                        }
                        break;
                    case "emballage_cadeau":
                        if (typeof tC.event.emballage_cadeau === "function") {
                            tC.event.emballage_cadeau(this, options);
                        }
                        break;
                    case "retrait_produit":
                        if (typeof tC.event.retrait_produit === "function") {
                            tC.event.retrait_produit(this, options);
                        }
                        break;
                    case "validation_panier":
                    case "choix_livraison":
                    case "choix_paiement":
                    case "modification_paiement":
                        if (typeof tC.event.checkout_progress === "function") {
                            tC.event.checkout_progress(this, options);
                        }
                        break;
                    case "login":
                    case "clic_type_identification":
                        if (typeof tC.event.login === "function") {
                            tC.event.login(this, options);
                        }
                        break;
                    case "subscription":
                        if (typeof tC.event.subscription === "function") {
                            tC.event.subscription(this, options);
                        }
                        break;
                    case "clic_configurateur_critere":
                        if (typeof tC.event.clic_configurateur_critere === "function") {
                            tC.event.product_interaction(this, options);
                        }
                        break;
                    case "guide_des_tailles":
                        if (typeof tC.event.guide_des_tailles === "function") {
                            tC.event.guide_des_tailles(this, options);
                        }
                        break;
                    case "filtres":
                        if (typeof tC.event.filtres === "function") {
                            tC.event.filtres(this, options);
                        }
                        break;
                    case "clic_alma":
                        if (typeof tC.event.clic_alma == "function") {
                            tC.event.clic_alma(this, options);
                        }
                        break;
                    case "retrait_bijouterie":
                        if (typeof tC.event.clic_alma == "function") {
                            tC.event.retrait_bijouterie(this, options);
                        }
                        break;
                    case "enregistrer_perso":
                        if (typeof tC.event.enregistrer_perso == "function") {
                            tC.event.enregistrer_perso(this, options);
                        }
                        break;
                    case "divers":
                        if (typeof tC.event.clic_divers == "function") {
                            tC.event.clic_divers(this, options);
                        }
                        break;

                    default: break;
                }
            }

            if (typeof (tc_vars) != "undefined") {
                if (tc_vars['env_work'] != 'PRODUCTION') {
                    //console.log("track_event : '" + trigger + "' // options = " + JSON.stringify(options));
                    console.log(trigger);
                    console.dir(options);
                }
            }
        },
        track_tc_event: function (data) {
            this.track_event(data.obj, data.trigger, data.options);
        },
        trackAddToCart: function (infos) {
            if (typeof (tc_vars) != 'undefined' && tc_vars && tc_vars.order_last_product_added) {
                var options = {
                    id: "ajout_panier",
                    category: infos.category,
                    action: tc_vars.order_last_product_added.product_category,
                    label: tc_vars.order_last_product_added.product_name + '|' + tc_vars.order_last_product_added.product_id,
                    value: tc_vars.order_last_product_added.product_unitprice_ati,
                    product_cat1: tc_vars.order_last_product_added.product_cat1,
                    product_cat2: tc_vars.order_last_product_added.product_cat2,
                    product_cat3: tc_vars.order_last_product_added.product_cat3,
                    product_category: tc_vars.order_last_product_added.product_category,
                    product_discount_tf: tc_vars.order_last_product_added.product_discount_tf,
                    product_discount_ati: tc_vars.order_last_product_added.product_discount_ati,
                    product_customizable: tc_vars.order_last_product_added.product_customizable,
                    product_gravable: tc_vars.order_last_product_added.product_gravable,
                    product_engraved: tc_vars.order_last_product_added.product_engraved,
                    product_id: tc_vars.order_last_product_added.product_id,
                    product_name: tc_vars.order_last_product_added.product_name,
                    product_promo: tc_vars.order_last_product_added.product_promo,
                    product_promo_label: tc_vars.order_last_product_added.product_promo_label,
                    product_quantity: tc_vars.order_last_product_added.product_quantity,
                    product_rating: tc_vars.order_last_product_added.product_rating,
                    product_size: tc_vars.order_last_product_added.product_size,
                    product_trademark: tc_vars.order_last_product_added.product_trademark,
                    product_unitprice_ati: tc_vars.order_last_product_added.product_unitprice_ati,
                    product_unitprice_tf: tc_vars.order_last_product_added.product_unitprice_tf
                };

                this.track_event(this, infos.trigger, options);
            }
        },
        trackClickAlma: function (data) {
            if (typeof (tc_vars) != 'undefined') {
                const options = {
                    id: "clic_alma",
                    category: "alma",
                    action: `${tc_vars.product_name} - ${tc_vars.product_id}`,
                    label: tc_vars.product_url,
                    value: tc_vars.product_unitprice_ati,
                    product_cat1: tc_vars.product_cat1,
                    product_cat2: tc_vars.product_cat2,
                    product_cat3: tc_vars.product_cat3,
                    product_category: tc_vars.product_category,
                    product_discount_tf: tc_vars.product_discount_tf,
                    product_discount_ati: tc_vars.product_discount_ati,
                    product_gravable: tc_vars.product_gravable,
                    product_customizable: tc_vars.product_customizable,
                    product_id: tc_vars.product_id,
                    product_name: tc_vars.product_name,
                    product_promo: tc_vars.product_promo,
                    product_promo_label: tc_vars.product_promo_label,
                    product_rating: tc_vars.product_rating,
                    product_trademark: tc_vars.product_trademark,
                    product_unitprice_ati: tc_vars.product_unitprice_ati,
                    product_unitprice_tf: tc_vars.product_unitprice_tf
                };

                this.track_event(this, "clic_alma", options);
            }
        },
        trackWishlist: function (infos) {
            if (typeof (tc_vars) != 'undefined') {
                const options = {
                    id: "clic_favoris",
                    category: "favoris",
                    action: infos.action,
                    label: tc_vars["product_name"] + " - " + tc_vars["product_id"],
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    //product_quantity: tc_vars["product_quantity"],
                    product_rating: tc_vars["product_rating"],
                    //product_size: tc_vars["product_size"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                this.track_event(this, "clic_favoris", options);
            }
        },
        trackClickAndCollectModal: function () {
            if (typeof (tc_vars) != 'undefined') {
                const options = {
                    id: "retrait_bijouterie",
                    category: "retrait bijouterie",
                    action: tc_vars["product_category"],
                    label: tc_vars["product_name"] + " - " + tc_vars["product_id"],
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_engraved: tc_vars["product_engraved"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    product_rating: tc_vars["product_rating"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                this.track_event(this, "clic_favoris", options);
            }
        },
        trackEReservation: function (category) {
            if (typeof (tc_vars) != 'undefined') {
                const options = {
                    id: "e_reservation",
                    category,
                    action: tc_vars["product_category"],
                    label: tc_vars["product_name"] + " - " + tc_vars["product_id"],
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_engraved: tc_vars["product_engraved"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    product_rating: tc_vars["product_rating"],
                    product_size: tc_vars["variante"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                this.track_event(this, "e_reservation", options);
            }
        },
        trackModals: function (action) {
            if (typeof (tc_vars) != 'undefined') {
                const options = {
                    id: "onglet_fp",
                    category: "onglet fiche produit",
                    action,
                    label: tc_vars["product_name"] + " - " + tc_vars["product_id"],
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_engraved: tc_vars["product_engraved"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    product_rating: tc_vars["product_rating"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                this.track_event(this, "onglet_fp", options);
            }
        },
        trackSaveCustomization: function () {
            if (typeof (tc_vars) != 'undefined') {
                const options = {
                    id: "enregistrer_perso",
                    category: "personnalisation",
                    action: tc_vars["product_category"],
                    label: tc_vars["product_name"] + "-" + tc_vars["product_id"],
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_engraved: tc_vars["product_engraved"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    product_rating: tc_vars["product_rating"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                this.track_event(this, "enregistrer_perso", options);
            }
        },
        trackObfuscatedLink: function (name, url = null, el = null) {
            if (typeof (tc_vars) != 'undefined') {
                let trigger = null;

                const options = {
                    id: null,
                    category: null,
                    action: tc_vars["product_name"] + " - " + tc_vars["product_id"],
                    label: null,
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_engraved: tc_vars["product_engraved"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    product_rating: tc_vars["product_rating"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                if (name == "sizeGuide") {
                    options.id = "guide_des_tailles";
                    options.category = "guide des tailles";
                    options.label = url;

                    trigger = "guide_des_tailles";
                } else if (name == "divers") {
                    options.id = "clic_divers";
                    options.category = "divers";
                    options.label = url;

                    trigger = "divers";
                }

                if (trigger) {
                    this.track_event(this, trigger, options);
                }
            }
        },
        trackObfuscatedLink: function (name, url = null) {
            if (typeof (tc_vars) != 'undefined') {
                let trigger = null;

                const options = {
                    id: null,
                    category: null,
                    action: tc_vars["product_name"] + "-" + tc_vars["product_id"],
                    label: null,
                    value: tc_vars["product_unitprice_ati"],
                    product_cat1: tc_vars["product_cat1"],
                    product_cat2: tc_vars["product_cat2"],
                    product_cat3: tc_vars["product_cat3"],
                    product_category: tc_vars["product_category"],
                    product_discount_tf: tc_vars["product_discount_tf"],
                    product_discount_ati: tc_vars["product_discount_ati"],
                    product_gravable: tc_vars["product_gravable"],
                    product_customizable: tc_vars["product_customizable"],
                    product_engraved: tc_vars["product_engraved"],
                    product_id: tc_vars["product_id"],
                    product_name: tc_vars["product_name"],
                    product_promo: tc_vars["product_promo"],
                    product_promo_label: tc_vars["product_promo_label"],
                    product_rating: tc_vars["product_rating"],
                    product_trademark: tc_vars["product_trademark"],
                    product_unitprice_ati: tc_vars["product_unitprice_ati"],
                    product_unitprice_tf: tc_vars["product_unitprice_tf"]
                }

                if (name == "sizeGuide") {
                    options.id = "guide_des_tailles";
                    options.category = "guide des tailles";
                    options.label = url;

                    trigger = "guide_des_tailles";
                }

                if (trigger) {
                    this.track_event(this, trigger, options);
                }
            }
        },
        events: function () {
            if (typeof (tc_vars) != 'undefined') {
                var self = this;

                $(this.scope)
                    .off('.fndtn.mastertag')
                    .on('click.fndtn.mastertag', '[' + self.attr_name() + ']', function (evt) {

                        self.settings = $.extend({}, self.defaults, self.data_options($(this)));

                        var trigger = $(this).data('trigger');

                        switch (trigger) {
                            case "autopromo":
                                if (typeof (tc_vars) != "undefined") {
                                    var evt_opt = {};
                                    var action_type = self.settings['action_type'];

                                    if (typeof (action_type) != "undefined") {
                                        switch (action_type) {
                                            case 'homeProduct':
                                            case 'carrouselProduct':
                                                var action = self.settings['carrousel_type'];

                                                if (typeof (action) === "undefined" || action == "") {
                                                    var zone = $(this).attr('data-zone');
                                                    switch (zone) {
                                                        case "FP_VOUS_AIMEREZ_AUSSI":
                                                            action = "vous aimerez aussi";
                                                            break;
                                                        case "FP_MUST_HAVE":
                                                            action = "vos coups de coeur";
                                                            break;
                                                        case "FP_JEWELLERY_SET":
                                                            action = "composez votre parure";
                                                            break;
                                                    }
                                                }

                                                self.track_event(this, 'clic_carrousel_produits', {
                                                    id: "clic_produit",
                                                    category: "sliders",
                                                    action,
                                                    label: tc_vars['product_name'] + ' - ' + tc_vars['product_id'],
                                                    value: self.settings['product_price'],
                                                    product_id: self.settings['product_id'].replace(new RegExp("'", 'g'), ''),
                                                    product_name: self.settings['product_name'].replace(new RegExp("'", 'g'), ''),
                                                    product_trademark: self.settings['product_brand'].replace(new RegExp("'", 'g'), '').toLowerCase(),
                                                    product_promo: self.settings['product_promo'],
                                                    product_promo_label: self.settings['product_promo_label'],
                                                    product_rating: self.settings['product_rating'],
                                                    product_unitprice_ati: self.settings['product_unitprice_ati'],
                                                    product_unitprice_tf: self.settings['product_unitprice_tf'],
                                                    product_discount_ati: self.settings['product_discount_ati'],
                                                    product_discount_tf: self.settings['product_discount_tf'],
                                                    product_customizable: tc_vars["product_customizable"],
                                                    product_gravable: self.settings['product_gravable'],

                                                    product_category: self.settings['product_category'],
                                                    product_cat1: self.settings['product_cat1'],
                                                    product_cat2: self.settings['product_cat2'],
                                                    product_cat3: self.settings['product_cat3'],

                                                });
                                                break;

                                            case "configurator":
                                                self.track_event(this, "clic_configurateur_produit", {
                                                    id: "clic_produit",
                                                    category: "configurateur",
                                                    action: self.settings['action'],
                                                    label: self.settings['product_name'] + ' - ' + self.settings['product_id'],
                                                    value: self.settings['product_price'],
                                                    product_customizable: true,
                                                    product_id: self.settings['product_id'],
                                                    product_name: self.settings['product_name'].toLowerCase(),
                                                    product_unitprice_ati: self.settings['product_price'],
                                                    product_unitprice_tf: self.settings['product_price_tf']
                                                })
                                                break;
                                        }
                                    }
                                }
                                break;

                            case "produit-onglet":
                                self.track_event(this, 'onglet_fp', evt_opt = {
                                    id: 'onglet_fp',
                                    category: 'onglet fiche produit',
                                    action: self.settings['target_name']
                                });
                                break;
                        }
                    });
            }
        },
        reflow: function () { }
    };
}(jQuery, window, window.document));